export const inspectionTypeRunsKeys = {
  all: (vehicleId: string) => ['recon', 'vehicles', vehicleId, 'inspection-types'] as const,
  lists: (vehicleId: string) => [...inspectionTypeRunsKeys.all(vehicleId), 'list'] as const,
  list: (vehicleId: string, name: string, inspectionId?: string | null) =>
    [...inspectionTypeRunsKeys.lists(vehicleId), name, inspectionId] as const,
  details: (vehicleId: string) => [...inspectionTypeRunsKeys.all(vehicleId), 'detail'] as const,
  detail: (vehicleId: string, typeRunId: string) => [...inspectionTypeRunsKeys.details(vehicleId), typeRunId] as const,
}
